import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import './assets/iconfont/iconfont.css'
import './style/index.css'
import directives from '@/directive'
import i18n from './i118n' // lang i18n
import axios from "axios";
import http from "./http";
import './components/SvgIcon' // icon
import Mixins from '@/mixin'
import Contextmenu from "./components/Contextmenu/index"

const Pagination=()=>import('./components/Pagination')
const VideoPlayer = () => import('./components/Videojs');
const TextEditor = () => import('./components/TextEditor/index.vue');
const AvatarUploader = () => import('./components/Upload/avatar.vue');

Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

//Syncfusion component
import { registerLicense,loadCldr } from '@syncfusion/ej2-base';
// import { SpreadsheetPlugin } from "@syncfusion/ej2-vue-spreadsheet";
import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';
// import { DocumentEditorContainerPlugin} from '@syncfusion/ej2-vue-documenteditor';
// import { RibbonPlugin } from "@syncfusion/ej2-vue-ribbon";

registerLicense(process.env.VUE_APP_SYNCFUSION_KEY);
// Vue.use(RibbonPlugin);
// Vue.use(DocumentEditorContainerPlugin);
// Vue.use(SpreadsheetPlugin);
Vue.use(SchedulePlugin);

//Syncfusion component Globalization
loadCldr(
  require('cldr-data/supplemental/numberingSystems.json'),
  require('cldr-data/main/zh/ca-gregorian.json'),
  require('cldr-data/main/zh/numbers.json'),
  require('cldr-data/main/zh/timeZoneNames.json'),
  require('cldr-data/main/zh/currencies.json')
);

import hevueImgPreview from 'hevue-img-preview'
Vue.use(hevueImgPreview,{
  keyboard: true,  
  clickMaskCLose: true,
  closeBtn:false
})

Vue.use(Mixins)
Vue.use(Contextmenu)
Vue.use(directives)

Vue.component('pagination',Pagination)
Vue.component("video-player", VideoPlayer);
Vue.component("text-editor", TextEditor);
Vue.component("avatar-uploader", AvatarUploader);

//vue-trix-editor
import VueTrix from './components/TrixEditor/index.vue'
Vue.component("vue-trix-editor", VueTrix)
Vue.config.ignoredElements = ['trix-editor']

Vue.config.productionTip = false;

Vue.prototype.$http = http;
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
